import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=e8dcd8d8&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports